import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Download, FileSpreadsheet, FileText, CheckCircle, Bot, AlertTriangle } from 'lucide-react';

const ExportResults = ({ uploadedFiles = [], onComplete, onProcessingChange }) => {
  const [showExplanation, setShowExplanation] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);
  const [showJson, setShowJson] = useState(false);

  const data = {
    "2022": {
      "Total Activo circulante": 1388918,
      "Total Activos no circulantes": 5627364,
      "Total Pasivo circulante": 4294655,
      "Total Pasivos no circulantes": 0,
      "Total Capital contable / Patrimonio": 2721627,
      "Total Ingresos y gastos": 1022616,
      "Total Otro resultado integral ORI": 0,
      "Total Ajustes a Ut ret": 0,
      "Total activos": 7016282,
      "Total pasivo y Cap contable": 7016282
    },
    "2023": {
      "Total Activo circulante": 2218535,
      "Total Activos no circulantes": 4984053,
      "Total Pasivo circulante": 3739842,
      "Total Pasivos no circulantes": 0,
      "Total Capital contable / Patrimonio": 3462746,
      "Total Ingresos y gastos": 996769,
      "Total Otro resultado integral ORI": 0,
      "Total Ajustes a Ut ret": 0,
      "Total activos": 7202588,
      "Total pasivo y Cap contable": 7202588
    }
  };

  useEffect(() => {
    if (uploadedFiles.length > 0 && !hasStarted) {
      setHasStarted(true);
      onProcessingChange && onProcessingChange(true);
      setTimeout(() => {
        setShowExplanation(true);
        onProcessingChange && onProcessingChange(false);
        if (onComplete) {
          onComplete({ status: 'success', message: 'Análisis completado' });
        }
      }, 2000);
    }
  }, [uploadedFiles, hasStarted]);

  return (
    <div style={{ padding: '24px', width: '100%', display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', paddingBottom: '24px', borderBottom: '1px solid #e5e7eb' }}>
        <div style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white', padding: '12px', borderRadius: '12px' }}>
          <Download size={32} />
        </div>
        <div>
          <h2 style={{ margin: '0 0 8px 0', fontSize: '24px', fontWeight: '700', color: '#1f2937' }}>Exportación y Resultados</h2>
          <p style={{ margin: '0', color: '#6b7280', fontSize: '16px' }}>Descarga de archivos y reporte final del análisis</p>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
        <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '24px' }}>
          <h3 style={{ margin: '0 0 16px 0', fontSize: '18px', fontWeight: '600' }}>Archivos Disponibles</h3>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <motion.button
              onClick={() => {
                const link = document.createElement('a');
                link.href = 'https://storage.googleapis.com/mantis-documents/TP%20proceso%20contable.xlsx';
                link.download = 'TP_proceso_contable.xlsx';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                }
              }
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                width: '100%',
                padding: '16px',
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              <FileSpreadsheet size={20} />
              <div style={{ flex: 1, textAlign: 'left' }}>
                <div>Descargar Excel Reclasificado</div>
                <div style={{ fontSize: '12px', opacity: 0.8 }}>Estados_Financieros_Reclasificados.xlsx</div>
              </div>
              <Download size={16} />
            </motion.button>

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                width: '100%',
                padding: '16px',
                background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              <FileText size={20} />
              <div style={{ flex: 1, textAlign: 'left' }}>
                <div>Ver Reporte de Errores</div>
                <div style={{ fontSize: '12px', opacity: 0.8 }}>Reporte_Observaciones.pdf</div>
              </div>
              <Download size={16} />
            </motion.button>

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                width: '100%',
                padding: '16px',
                background: '#f3f4f6',
                color: '#374151',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              <Bot size={20} />
              <div style={{ flex: 1, textAlign: 'left' }}>
                <div>Reporte de Análisis IA</div>
                <div style={{ fontSize: '12px', opacity: 0.8 }}>Explicación detallada del proceso</div>
              </div>
              <Download size={16} />
            </motion.button>
          </div>
        </div>

        <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '24px' }}>
          <h3 style={{ margin: '0 0 16px 0', fontSize: '18px', fontWeight: '600' }}>Resumen del Análisis</h3>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px', background: '#ecfdf5', borderRadius: '6px' }}>
              <span style={{ fontSize: '14px' }}>Documentos procesados</span>
              <span style={{ fontSize: '14px', fontWeight: '600', color: '#10b981' }}>3/3</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px', background: '#fffbeb', borderRadius: '6px' }}>
              <span style={{ fontSize: '14px' }}>Observaciones críticas</span>
              <span style={{ fontSize: '14px', fontWeight: '600', color: '#f59e0b' }}>1</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px', background: '#ecfdf5', borderRadius: '6px' }}>
              <span style={{ fontSize: '14px' }}>Reclasificaciones</span>
              <span style={{ fontSize: '14px', fontWeight: '600', color: '#10b981' }}>4</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px', background: '#ecfdf5', borderRadius: '6px' }}>
              <span style={{ fontSize: '14px' }}>Tiempo de procesamiento</span>
              <span style={{ fontSize: '14px', fontWeight: '600', color: '#10b981' }}>2.3 min</span>
            </div>
            <button
              style={{
                marginTop: '20px',
                padding: '8px 12px',
                backgroundColor: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
              }}
              onClick={() => setShowJson(!showJson)}
            >
              {showJson ? 'Ocultar JSON' : 'Mostrar JSON'}
            </button>
          </div>
        </div>
      </div>

      {showJson && (
        <pre
          style={{
            marginTop: '16px',
            padding: '12px',
            background: '#f3f4f6',
            borderRadius: '6px',
            fontSize: '12px',
            overflowX: 'auto',
            maxHeight: '400px',
          }}
        >
          {JSON.stringify(data, null, 2)}
        </pre>
      )}

      {showExplanation && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '12px', padding: '24px' }}
        >
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
            <AlertTriangle size={24} style={{ color: '#f59e0b', flexShrink: 0, marginTop: '4px' }} />
            <div>
              <h3 style={{ margin: '0 0 12px 0', fontSize: '18px', fontWeight: '700', color: '#92400e' }}>
                Explicación del Análisis - IA Mantis
              </h3>
              <div style={{ fontSize: '14px', lineHeight: '1.6', color: '#78716c' }}>
                <p style={{ margin: '0 0 12px 0' }}>
                  <strong>Resultado:</strong> Detectamos que la empresa tiene activos por 6,300 SMMLV, por lo que requiere firma de Revisor Fiscal según la normativa vigente.
                </p>
                <p style={{ margin: '0 0 12px 0' }}>
                  <strong>Problema encontrado:</strong> La firma del Revisor Fiscal no fue encontrada en los documentos, por lo que estos serán devueltos para corrección.
                </p>
                <p style={{ margin: '0 0 12px 0' }}>
                  <strong>Reclasificaciones realizadas:</strong> Se identificaron y corrigieron 4 clasificaciones contables basadas en las notas a los estados financieros, incluyendo efectivo restringido, inversiones permanentes y anticipos a socios.
                </p>
                <p style={{ margin: '0' }}>
                  <strong>Recomendación:</strong> Obtener la firma del Revisor Fiscal correspondiente y reenviar los documentos para completar el proceso de validación.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      )}

      <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '24px' }}>
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          style={{
            padding: '12px 24px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          Reenviar Documentos Corregidos
        </motion.button>
        
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          style={{
            padding: '12px 24px',
            background: '#f3f4f6',
            color: '#374151',
            border: '1px solid #d1d5db',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          Finalizar Proceso
        </motion.button>
      </div>

      {/* <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        style={{ background: '#ecfdf5', border: '1px solid #d1fae5', borderRadius: '12px', padding: '24px', textAlign: 'center' }}
      >
        <CheckCircle size={48} style={{ color: '#10b981', margin: '0 auto 16px' }} />
        <h3 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: '700', color: '#065f46' }}>
          Demo Completado Exitosamente
        </h3>
        <p style={{ margin: '0', color: '#065f46', opacity: '0.8' }}>
          El análisis de estados financieros por IA ha sido completado
        </p>
      </motion.div> */}
    </div>
  );
};

export default ExportResults; 